import { isApiClientError } from "../api/errors";
import type { DocumentSubstitution } from "../api/generated";

export const substitutionStatuses: Record<
  DocumentSubstitution["status"],
  string
> = {
  scheduled: "Запланировано",
  active: "Действует",
  ended: "Завершено",
  cancelled: "Отменено",
};
export const substitutionReasons: Record<
  DocumentSubstitution["reason"],
  string
> = {
  vacation: "Отпуск",
  business_trip: "Командировка",
  sick_leave: "Больничный",
  other: "Другое",
};
export function substitutionError(error: unknown): string {
  if (isApiClientError(error)) {
    const messages: Record<string, string> = {
      "document_workflow.substitution_overlaps":
        "На этот период у сотрудника уже есть замещение",
      "document_workflow.substitution_chain":
        "Этот сотрудник уже замещает другого или будет замещаться в этот период",
      "document_workflow.substitution_member_invalid":
        "Заместитель должен быть действующим сотрудником этого КПО",
      "document_workflow.substitution_period_invalid":
        "Проверьте период замещения",
      "document_workflow.substitution_self":
        "Нельзя назначить заместителем самого себя",
      "document_workflow.substitution_not_active":
        "Состояние замещения изменилось. Обновите список",
    };
    if (messages[error.code]) return messages[error.code]!;
    if (error.status === 403)
      return "Нельзя назначить этого заместителя: он вне вашей иерархии подчинения";
    if (error.status === 404) return "Замещение недоступно в выбранном КПО";
  }
  return "Не удалось сохранить замещение. Повторите попытку";
}
export function localDateTime(value: Date): string {
  const number = (part: number) => String(part).padStart(2, "0");
  return `${value.getFullYear()}-${number(value.getMonth() + 1)}-${number(value.getDate())}T${number(value.getHours())}:${number(value.getMinutes())}`;
}
export function substitutionPeriodErrors(
  start: string,
  end: string,
  now = Date.now(),
): Record<string, string> {
  const first = new Date(start).getTime(),
    last = new Date(end).getTime();
  const errors: Record<string, string> = {};
  if (!Number.isFinite(first)) errors.starts_at = "Укажите начало замещения";
  if (!Number.isFinite(last)) errors.ends_at = "Укажите конец замещения";
  else if (last <= first) errors.ends_at = "Конец должен быть позже начала";
  else if (last <= now) errors.ends_at = "Конец должен быть в будущем";
  else if (last - first > 365 * 86400000)
    errors.ends_at = "Замещение не может длиться больше 365 дней";
  return errors;
}
export function substitutionScopeOptions(
  values: readonly unknown[],
): { id: string; name: string }[] {
  return values.flatMap((value) => {
    if (
      typeof value !== "object" ||
      value === null ||
      !("id" in value) ||
      !("name" in value) ||
      typeof value.id !== "string" ||
      typeof value.name !== "string"
    )
      return [];
    return [{ id: value.id, name: value.name }];
  });
}
